import { albumCover } from "constants/placeholderAlbumCover";
import React, { useState } from "react";
import styled from "styled-components";

import Navbar from "./components/navbar";
import Typography from "components/typography";
import TrackDetails from "./components/video-details";

import SocialMediaLinks from "./components/social-media-links";
import { Colors } from "utils/colors";
import VideoLinks from "./components/video-links";

const VideoShare = () => {
  const [isOwner, setIsOwner] = useState(true);

  return (
    <Main>
      <Container>
        <NavContainer>{isOwner && <Navbar />}</NavContainer>
        <Body>
          <TrackDetails />
          <VideoLinks />
          <SocialMediaLinks />
        </Body>
      </Container>
    </Main>
  );
};

export default VideoShare;

const Main = styled.main`
  width: 100%;
  background-color: ${Colors.grey900};
  min-height: 100vh;
  position: relative;
  max-height: 1920px;
  max-width: 1920px;
  @media only screen and (max-width: 769px) {
    overflow: hidden;
    width: 100vw;
    height: auto;
  }
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  z-index: 1;
  position: relative;
`;
const NavContainer = styled.div`
  height: 7rem;
`;

const Body = styled.div`
  width: 100%;
  padding: 6.8rem 6.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  @media only screen and (max-width: 769px) {
    flex-direction: column;
    padding: 2.4rem 2.4rem;
  }
`;
